import { MRWebPagePayload, ReportMonthlyWebPage } from 'commons/types/DTO/bank/reportWebPage'
import { Request } from 'commons/utils/request'

export const getMRWebPage = (payload?: MRWebPagePayload) =>
  Request.post<ReportMonthlyWebPage>(Request.urls.bank.reportMonthlyWebPage, { ...payload })
